import { render, staticRenderFns } from "./MovePresidentMessage.vue?vue&type=template&id=1c3c536d&scoped=true&"
import script from "./MovePresidentMessage.vue?vue&type=script&lang=js&"
export * from "./MovePresidentMessage.vue?vue&type=script&lang=js&"
import style0 from "./MovePresidentMessage.vue?vue&type=style&index=0&id=1c3c536d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c536d",
  null
  
)

export default component.exports